/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
    const a = 'is-active';
	const v = 'is-visible';

	const setSliderArrowTop = (s) => {
		let img = document.querySelector("." + s +"-item-img img");
		if(img) {
			let btn01 = document.querySelector("." + s +"-control .swiper-button-next");
			let btn02 = document.querySelector("." + s +"-control .swiper-button-prev");

			btn01.style.top = img.height / 2 + "px";
			btn02.style.top = img.height / 2 + "px";
		}
	}

	const slider = () => {
        
		if(document.querySelectorAll('.ir-slider01').length) {
			const topslider02 = new Swiper('.ir-slider01', {
				slidesPerView: 1,
				spaceBetween: 30,
				loop: true,
				loopAdditionalSlides: 0,
				speed: 1000,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.ir-slider01-control .swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.ir-slider01-control .swiper-button-next',
					prevEl: '.ir-slider01-control .swiper-button-prev',
				},
				breakpoints: {
					769: {
						slidesPerView: 3,
						spaceBetween: 28,
					},
				},
			});
			document.querySelector('.ir-slider01-control-button').addEventListener('click', (e) => {
				if(!(e.currentTarget.classList.contains(a))) {
					e.currentTarget.ariaLabel = '停止';
					e.currentTarget.classList.add(a);
					topslider02.autoplay.start();
				} else {
					e.currentTarget.ariaLabel = '再生';
					e.currentTarget.classList.remove(a);
					topslider02.autoplay.stop();
				}
			});
			setTimeout(() => {
				setSliderArrowTop("ir-slider01");
				document.querySelector('.ir-slider01-control').classList.remove('is-o0');
			}, 600);
			window.addEventListener('resize', () => {
				let resizeTime = 0;
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => {
					setSliderArrowTop("ir-slider01");
				}, 300);
			});
		}
	}

	slider();

	const setIframe = () => {
		let iframeElm = document.querySelector("#js-iframe-e");
		if(iframeElm) {
			EurolandToolIntegrationObject.set("js-iframe-e");
		}
	}
	document.addEventListener('DOMContentLoaded', function() {
		setIframe();
	});

})(window.FUNCTIONS);
